import React, { Component } from "react"
import {Switch, Route, NavLink} from "react-router-dom"
import {Role} from './Role'
// import {DarePage} from './dare'
import './style.css'

export class Fun extends Component {

    constructor(props) {
        super(props)
        this.state = {

        }
    }

    render() {
        return (
            <div className="fun-root main-back overflow-auto">
                <div className="main-content">
                    <div className="container my-4">
                        <div className="col-md-6 container my-2" ><a href='/fun/dare/1/'><img className="flip" style={{width: '100%'}} src={require(`../../static/img/list/card-turaanadaa.png`)}></img></a></div>
                        <div className="col-md-6 container my-2"><a href='/fun/dare/2/'><img className="flip" style={{width: '100%'}} src={require(`../../static/img/list/card-elgeemedeerei.png`)}></img></a></div>
                        <div className="col-md-6 container my-2"><a href='/fun/dare/3/'><img className="flip" style={{width: '100%'}} src={require(`../../static/img/list/card-ayultai.png`)}></img></a></div>
                        <div className="col-md-6 container my-2"><a href='/fun/dare/4/'><img className="flip" style={{width: '100%'}} src={require(`../../static/img/list/card-tuluu.png`)}></img></a></div>
                        <div className="col-md-6 container my-2"><a><img className="flip" style={{width: '100%'}} src={require(`../../static/img/list/card-dontoi.png`)}></img></a></div>
                        <div className="col-md-6 container my-2"><a><img className="flip" style={{width: '100%'}} src={require(`../../static/img/list/comingsoon.png`)}></img></a></div>
                    </div>
                </div>
                <div className="">
                    <Switch>
                        <Route path={"/fun/dare/:dare"} component={Role}/>
                    </Switch>
                </div>
            </div>
        )

    }

}
